"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var BusinessLogo = function BusinessLogo(_ref) {
  var img = _ref.img,
    size = _ref.size,
    className = _ref.className;
  var style = {
    width: size,
    height: "auto"
  };
  return /*#__PURE__*/_react["default"].createElement("img", {
    "data-testid": "BusinessLogo",
    src: img,
    style: style,
    alt: "Business Logo",
    className: className
  });
};
BusinessLogo.defaultProps = {
  size: '5em',
  className: '',
  img: undefined
};
var _default = BusinessLogo;
exports["default"] = _default;